import { render, staticRenderFns } from "./addOrUpdateClientContractInfo.vue?vue&type=template&id=c9480b3e&scoped=true"
import script from "./addOrUpdateClientContractInfo.vue?vue&type=script&lang=js"
export * from "./addOrUpdateClientContractInfo.vue?vue&type=script&lang=js"
import style0 from "./addOrUpdateClientContractInfo.vue?vue&type=style&index=0&id=c9480b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9480b3e",
  null
  
)

export default component.exports